import {
  getObject,
  getOptionalObject,
} from "@surya-digital/leo-ts-types";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";
import { Code, CodeDTO } from "./code";

export interface OpenEndedFieldV1DTO {
  optionFieldTitle?: SurveyLocalizedTextDTO | null;
  optionFieldHint?: SurveyLocalizedTextDTO | null;
  optionCode: CodeDTO;
}

export class OpenEndedFieldV1 {
  readonly isOpenEndedFieldV1OpenEndedFieldV1: boolean = true;

  readonly optionFieldTitle: SurveyLocalizedText | null;
  readonly optionFieldHint: SurveyLocalizedText | null;
  readonly optionCode: Code;


  constructor(
  optionFieldTitle: SurveyLocalizedText | null = null, 
  optionFieldHint: SurveyLocalizedText | null = null, 
  optionCode: Code
  ) {
    this.optionFieldTitle = optionFieldTitle;
    this.optionFieldHint = optionFieldHint;
    this.optionCode = optionCode;
  }

  static fromDTO(dto: OpenEndedFieldV1DTO): OpenEndedFieldV1 {
    let optionFieldTitle = getOptionalObject(dto, "optionFieldTitle");
    if(optionFieldTitle !== undefined && optionFieldTitle !== null) {
      optionFieldTitle = SurveyLocalizedText.fromDTO(getObject(dto, "optionFieldTitle", InvalidOpenEndedFieldV1OptionFieldTitleError));
    }
    let optionFieldHint = getOptionalObject(dto, "optionFieldHint");
    if(optionFieldHint !== undefined && optionFieldHint !== null) {
      optionFieldHint = SurveyLocalizedText.fromDTO(getObject(dto, "optionFieldHint", InvalidOpenEndedFieldV1OptionFieldHintError));
    }
    const optionCode = Code.fromDTO(getObject(dto, "optionCode", InvalidOpenEndedFieldV1OptionCodeError));
    return new OpenEndedFieldV1(
      optionFieldTitle,
      optionFieldHint,
      optionCode
    );
  }

  toDTO(): OpenEndedFieldV1DTO {
    const dto: OpenEndedFieldV1DTO = {
        optionCode: this.optionCode.toDTO()
    };
    if (this.optionFieldTitle !== undefined && this.optionFieldTitle !== null){
      dto.optionFieldTitle = this.optionFieldTitle.toDTO();
    }
    if (this.optionFieldHint !== undefined && this.optionFieldHint !== null){
      dto.optionFieldHint = this.optionFieldHint.toDTO();
    }
    return dto;
  }
  }

OpenEndedFieldV1.prototype.toString = function toString(): string {
  return `OpenEndedFieldV1(optionFieldTitle='${this.optionFieldTitle}',optionFieldHint='${this.optionFieldHint}',optionCode='${this.optionCode}')`;
};

export class InvalidOpenEndedFieldV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedFieldV1Error";
  }
}
export class InvalidOpenEndedFieldV1OptionFieldTitleError extends InvalidOpenEndedFieldV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedFieldV1OptionFieldTitleError";
  }
}

export class InvalidOpenEndedFieldV1OptionFieldHintError extends InvalidOpenEndedFieldV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedFieldV1OptionFieldHintError";
  }
}

export class InvalidOpenEndedFieldV1OptionCodeError extends InvalidOpenEndedFieldV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedFieldV1OptionCodeError";
  }
}
